export enum ZonesAreasButtonState {
  ZONES_DISPLAYED = 'ZONES_DISPLAYED',
  ZONES_AREAS_DISPLAYED = 'ZONES_AREAS_DISPLAYED',
  NONE_DISPLAYED = 'NONE_DISPLAYED',
}
